import { SaveEdits, validateImageFileName } from "./_utils";

var $ = jQuery;

export const SmartMTAlert = (content, actionBtns) => {
    let alertHtml = `
        <div id="smartmt-alert" class="smartmt">
            <div id="smart-mt-alert-wrapper">
                <div id="smart-mt-alert-header"><span class="dashicons dashicons-info-outline"></span><button class="smart-mt-alert-close"><span class="dashicons dashicons-no-alt"></span></button></div>
                <div id="smart-mt-alert-content">${content}</div>
                <div id="smart-mt-alert-footer">${actionBtns}</div>
            </div>
        </div>`;

    if ($('#smartmt-alert').length) {
        $('#smart-mt-alert-content').html(content);
    }
    else {
        $('body').append(alertHtml);
        
        // Closing alert.
        $('.smart-mt-alert-close').on('click', function () {
            $('#smartmt-alert').remove();
        });

        // Save edits.
        $('#smart-mt-save').on('click', function() {
            $(this).text('Saving...');
            SaveEdits();
        });
        // Show preview of file name.
        $('#smart-mt-new-name').on('input change', function() {
            validateImageFileName($(this).val());
        });
        
        // Save edits as new file.
        $('#smart-mt-save-as').on('click', function() {
            $(this).text('Saving...');

            let fileName = $('#smart-mt-validated-new-name').val();
            let title = $('#smart-mt-new-name').val();
            SaveEdits(fileName, title);
        });
    }
};
